export default {
    // table 数据
    getVendorList: "/vendor/show",
    // vendor Type
    getVendorType:"/vendor/vendorType",
    //vendor add
    getVendorAdd:"/vendor/add",
    // vendor 上传
    getVendorUpload:"/vendor/upload",
    // vendor 修改
    getVendorUpdate:"/vendor/update",
    // vendor  根据ID查询回显
    getVendorData:"/vendor/ById",
    // vendor 查询PDF
    getVendorPDF:"/file/fileDetails",
    // vendor by payment
    getVendorByPayment:"/vendor/showVendorIdByPayments"
}